import { useEffect } from 'react'
import { useAuthStore } from './auth.store'

/**
 * Hook para simular autenticación en desarrollo
 * SOLO USAR EN DESARROLLO
 */
export const useDevAuth = () => {
  const { setUser, setPermissions, setAuthenticated, setLoading } = useAuthStore()

  useEffect(() => {
    // Simular delay de carga
    const timer = setTimeout(() => {
      // Simular usuario autenticado
      setUser({
        id: '1',
        email: 'dev@example.com',
        firstName: 'Dev',
        lastName: 'User',
        fullName: 'Dev User',
        role: 'admin',
        isActive: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      })

      // Simular permisos (incluye permisos para example y atención)
      setPermissions({
        example: {
          access: true,
          read: true,
          write: true,
        },
        atencion: {
          access: true,
          read: true,
          write: true,
        },
        users: {
          access: true,
          read: true,
        },
        cammovem: {
          access: true,
          read: true,
          write: true,
        },
        flowconfig: {
          access: true,
          read: true,
          write: true,
          delete: true,
        },
        buzoncitas: { 
          access: true,
          read: true,
          write: true,
        },
        desbloquearcita: { 
          access: true,
          read: true,
          write: true,
        },
      })

      // Marcar como autenticado y no cargando
      setAuthenticated(true)
      setLoading(false)
    }, 1000)

    return () => clearTimeout(timer)
  }, [setUser, setPermissions, setAuthenticated, setLoading])
}